export enum DateFilterEnum {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  CURRENT_WEEK = 'CURRENT_WEEK',
  LAST_WEEK = 'LAST WEEK',
  CURRENT_MONTH = 'CURRENT_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  CURRENT_YEAR = 'CURRENT_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_60_DAYS = 'LAST_60_DAYS',
  LAST_90_DAYS = 'LAST_90_DAYS',
  LIFETIME = 'LIFETIME',
  DATE_RANGE = 'DATE_RANGE',
}
